<template>
    <div class="container mt-4">
      <h2 class="text-center">Listado de Mujeres Embarazadas</h2>
  
       <div class="row">
        <div class="col-md-6">
        <div class="d-flex justify-content-start">
          <!-- Botón para agregar mujer embarazada -->
          <button class="btn btn-purple text-white">
            <router-link to="/mujer/add" class="nav-link">
              <strong class="text-white">Agregar mujer embarazada 🤰</strong>
            </router-link>
          </button>

          <!-- Botón para exportar Excel -->
          <button class="btn btn-success ml-2" @click="exportToExcel">
            <strong class="text-white">Exportar Excel</strong>
          </button>
        </div>
      </div>

      <div class="col-md-6 text-right">
        <button class="btn btn-info">
          <router-link to="/registros" class="nav-link">
            <strong class="text-white">Volver</strong> 
          </router-link>
        </button>
      </div>
    </div>


      <br>
      <br>

      <div class="alert alert-info" role="alert">
      <strong>Importante:</strong> Seleccione (dar click o presione) sobre algún registro para editar o agregar información.
    </div>

      <div class="table-responsive table-container">
        <table id="myTable" class="table table-hover table-sm custom-table">
          <thead>
            <tr>
              <th scope="col">Cédula</th>
              <th scope="col">Nombres</th>
              <th scope="col">Apellidos</th>
              <th scope="col">Provincia</th>
              <th scope="col">Cantón</th>
              <th scope="col">Celular</th>
              <th scope="col">Fecha de Registro</th>
              <th scope="col">Responsable del Registro</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(mujer, index) in filteredMujer" :key="index" @click="redirectToMujer(mujer._id)">
              <td>{{ mujer.cedula }}</td>
              <td>{{ mujer.nombres }}</td>
              <td>{{ mujer.apellidos }}</td>
              <td>{{ mujer.provincia }}</td>
              <td>{{ mujer.canton }}</td>
              <td>{{ mujer.celular }}</td>
              <td>{{ formatUTCDate(mujer.fechaRegistro) }}</td>
              <td>{{ mujer.createdBy.nombre }} {{ mujer.createdBy.apellido }}    </td>
              <button class="btn btn-primary btn-sm" @click="generatePDF(mujer._id)">
          Generar PDF
        </button>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  import { BASE_URL } from '../store/config';
  import ExcelJS from 'exceljs';

  import jsPDF from 'jspdf';


  
  export default {
    computed:{
        currentUser() {
      return this.$store.state.auth.user;
    },
  filteredMujer() {
      if (this.currentUser.roles.includes('ROLE_BRIGADA')) {
        return this.mujeres.filter(mujer => mujer.createdBy.cedula === this.currentUser.cedula);
      } else {
        return this.mujeres;
      }
    },
  },
    data() {
      return {
        mujeres: [],
        errorLoadingMujeres: null,
      };
    },
    methods: {
      generatePDF(mujerId) {
      // Realiza la petición para obtener los datos del informe PDF
      axios.get(`${BASE_URL}/api/mujer/pdf/${mujerId}`, {
        headers: {
          'x-access-token': this.$store.state.auth.user.accessToken,
        },
      })
      .then(response => {
        // Extrae los datos de la respuesta
        const { mujer, vacunaMujerData, controlMujerData, etmiData } = response.data;
    const pdf = new jsPDF();

    var imagenlogo = "data:image/jpeg;base64,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"
    
    pdf.addImage(imagenlogo, 160,10,35,30);

        pdf.text(20, 20, 'Información General de la Mujer Embarazada');
    pdf.setFontSize(12);

    pdf.text(20, 30, `HCU: ${mujer.hcu}`);
    pdf.text(20, 40, `Cédula: ${mujer.cedula}`);
    pdf.text(20, 50, `Nombres: ${mujer.nombres}`);
    pdf.text(20, 60, `Apellidos: ${mujer.apellidos}`);
    pdf.text(20, 70, `Discapacidad: ${mujer.discapacidad}`);
    pdf.text(20, 80, `Detalle Discapacidad: ${mujer.detalleDiscapacidad}`);
    pdf.text(20, 90, `Teléfono Domicilio: ${mujer.telfdomicilio}`);
    pdf.text(20, 100, `Celular: ${mujer.celular}`);
    pdf.text(20, 110, `Dirección: ${mujer.direccion}`);
    pdf.text(20, 120, `Zona: ${mujer.zona}`);
    pdf.text(20, 130, `Provincia: ${mujer.provincia}`);
    pdf.text(20, 140, `Cantón: ${mujer.canton}`);
    pdf.text(20, 150, `Parroquia: ${mujer.parroquia}`);
    pdf.text(20, 160, `Establecimiento: ${mujer.establecimiento}`);
    

    // Sección de Vacunas
    pdf.addPage(); // Nueva página para la siguiente sección
    pdf.setFontSize(18);
    pdf.text(20, 20, 'Información de Vacunas');
    pdf.setFontSize(12);

    vacunaMujerData.forEach((vacuna, index) => {
  const yPosition = 30 + index * 20; // Aumentar de 20 en 20

  pdf.text(20, yPosition, `Vacuna ${index + 1}:`);
  pdf.text(40, yPosition + 10, `Tipo: ${vacuna.tipo}`);
  pdf.text(40, yPosition + 20, `Dosis: ${vacuna.dosis}`);
  pdf.text(40, yPosition + 30, `Fecha de Aplicación: ${vacuna.fechaaplicacion.slice(0,10)}`);
  pdf.text(40, yPosition + 40, `Edad de Aplicación: ${vacuna.edadapli}`);
  pdf.text(40, yPosition + 50, `Lote: ${vacuna.lote}`);
  pdf.text(40, yPosition + 60, `Vacunador: ${vacuna.vacunador}`);
  pdf.text(40, yPosition + 70, `Nombre de la Vacuna: ${vacuna.nombrevacuna}`);
  pdf.text(40, yPosition + 80, `Establecimiento: ${vacuna.establecimiento}`);
  // Puedes agregar más detalles si es necesario
});

    // Sección de Controles
    pdf.addPage();
    pdf.setFontSize(18);
    pdf.text(20, 20, 'Información de Controles');
    pdf.setFontSize(12);

    controlMujerData.forEach((control, index) => {
  const yPosition = 30 + index * 20; // Aumentar de 20 en 20

  pdf.text(20, yPosition, `Control ${index + 1}:`);
  pdf.text(40, yPosition + 10, `Fecha de Atención: ${control.fechaatencion.slice(0, 10)}`);
  pdf.text(40, yPosition + 20, `Fecha Próxima: ${control.fechaproxima.slice(0, 10)}`);
  pdf.text(40, yPosition + 30, `Nombre del Vacunador: ${control.nombrevacunador}`);
  pdf.text(40, yPosition + 40, `Observación: ${control.observacion}`);
  // Puedes agregar más detalles si es necesario
});


    // Sección de ETMI
    pdf.addPage();
    pdf.setFontSize(18);
    pdf.text(20, 20, 'Información de ETMI');
    pdf.setFontSize(12);

    etmiData.forEach((etmi, index) => {
  const yPosition = 30 + index * 20; // Aumentar de 10 en 10
  pdf.text(20, yPosition, `ETMI ${index + 1}: Trimestre: ${etmi.nombre}`);

 
  etmi.tamizajes.forEach((tamizaje, tamizajeIndex) => {
    const tamizajeYPosition = yPosition + (tamizajeIndex + 1) * 10; 
    pdf.text(40, tamizajeYPosition, `Enfermedad:  ${tamizaje.vacuna}, Resultado : ${tamizaje.resultado} 
    ,Semana de gestación: ${tamizaje.semanaGestacion}, Fecha Realización: ${tamizaje.fechaRealizacion.slice(0,10)}`);
   
  });
});

    const pdfFileName = `informe_mujer_${mujer.cedula}.pdf`;
    pdf.save(pdfFileName);
  })
  .catch(error => {
    console.error('Error al generar PDF:', error);
  });
},
      
      formatUTCDate(dateString) {
      // Crea un objeto Date a partir de la cadena de fecha
      const date = new Date(dateString);

      // Utiliza toLocaleString() con la opción de zona horaria
      return date.toLocaleString('es-EC', { timeZone: 'America/Guayaquil' });
    },
      redirectToMujer(mujerId) {
      this.$router.push({ name: 'mujer', params: { mujerId } });
    },
      loadMujeres() {
        axios
          .get(`${BASE_URL}/api/mujer`, {
            headers: {
              'x-access-token': this.$store.state.auth.user.accessToken,
            },
          })
          .then(response => {

            this.mujeres = response.data;
            this.$nextTick(() => {
            $('#myTable').DataTable({
              responsive: true,
              language: {
                url: 'https://cdn.datatables.net/plug-ins/1.10.25/i18n/Spanish.json',
              },
              pageLength: 5,
              order: [[6, 'desc']],
            
            });
          });
        })
          .catch(error => {
            this.errorLoadingMujeres = 'Error al cargar mujeres. Por favor, inténtalo de nuevo.';
            console.error('Error al cargar mujeres:', error);
          });
      },
      exportToExcel() {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Mujeres Embarazadas');

      const headers = [
        'HCU',
        'Cédula',
        'Nombres',
        'Apellidos',
        'Discapacidad',
        'Detalle Discapacidad',
        'Teléfono Domicilio',
        'Celular',
        'Dirección',
        'Zona',
        'Provincia',
        'Cantón',
        'Parroquia',
        'Establecimiento',
        'Fecha Registro',
      ];
      worksheet.addRow(headers);

      this.mujeres.forEach(mujer => {
        const row = [
          mujer.hcu,
          mujer.cedula,
          mujer.nombres,
          mujer.apellidos,
          mujer.discapacidad,
          mujer.detalleDiscapacidad,
          mujer.telfdomicilio,
          mujer.celular,
          mujer.direccion,
          mujer.zona,
          mujer.provincia,
          mujer.canton,
          mujer.parroquia,
          mujer.establecimiento,
          mujer.fechaRegistro.slice(0, 10),
        ];
        worksheet.addRow(row);
      });

      workbook.xlsx.writeBuffer().then(buffer => {
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const fileName = 'mujeres_embarazadas.xlsx';

        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
      });
    },
    },
    mounted() {

        this.loadMujeres();
      }
    
  };
  </script>
  
  <style scoped>
  .btn-purple {
    background-color: purple;
    border-color: purple;
  }
  
  .custom-table {
    background-color: #92ce95; /* Color de fondo morado */
    border-collapse: separate;
    border-spacing: 0 1px; /* Espaciado vertical entre las filas */
  }
  
  .custom-table tbody tr:hover {
    background-color: rgba(191, 245, 205, 0.835); /* Color celeste pastel en hover */
  }
  
  /* Estilo para las líneas de la tabla de DataTables */
  table.dataTable.no-footer {
    border-bottom: 1px ; /* Cambia el color y el grosor según tus preferencias */
  }
  
  table.dataTable thead th, table.dataTable thead td {
    border-bottom: 1px ; /* Cambia el color y el grosor según tus preferencias */
  }
  </style>
  